import { FeePreviewResponse } from '@/types/sso';
import useLanguage from '@/utils/hooks/useLanguage';
import { useSso } from '@/utils/providers/SSOProvider';
import { Fragment, useMemo } from 'react';
import FeeDisplay from './FeeDisplay';

export type FeePreviewProps = {
    feesDetails?: FeePreviewResponse[];
    isLoadingFeesDetails: boolean;
    feesDetailsError?: any;
};

const tradeHasNoRuleError = /No applicable fee rule found for the trade./;

const FeePreview = ({ feesDetails, isLoadingFeesDetails, feesDetailsError }: FeePreviewProps) => {
    const { instrumentCurrenciesApi } = useSso();
    const { data: instrumentCurrenciesData = [] } = instrumentCurrenciesApi;
    const lang = useLanguage();

    const hasNoRuleError = useMemo(() => {
        // 'No applicable fee rule found for the trade.'
        return tradeHasNoRuleError.test(feesDetailsError?.message || '');
    }, [feesDetailsError]);

    {
        /* {feesDetailsError && <FeeDisplay defaultLabel={feesDetailsError.message} isError={!hasNoRuleError} />} */
    }

    {
        /* Loading */
    }
    {
        isLoadingFeesDetails && (
            <FeeDisplay defaultLabel={lang.orderForm.estimatingFees} isLoading={isLoadingFeesDetails} />
        );
    }

    // Show loading state only if currently loading AND no data exists yet
    const shouldShowLoading = useMemo(
        () => isLoadingFeesDetails && (!feesDetails || feesDetails.length === 0),
        [isLoadingFeesDetails, feesDetails]
    );

    // Show data if available, regardless of loading state (smooth transition)
    const shouldShowData = useMemo(() => feesDetails && feesDetails.length > 0, [feesDetails]);

    return (
        <Fragment>
            {/* Fees - shows data and keeps displaying while revalidating */}
            {shouldShowData && (
                <FeeDisplay
                    defaultLabel={lang.orderForm.estimatedFees}
                    isLoading={isLoadingFeesDetails}
                    items={feesDetails?.map((fee) => {
                        const currency = instrumentCurrenciesData?.find((c) => c.id === fee.feeCurrencyId);
                        return {
                            value: `${fee.calculatedFeeAmount} ${currency?.assetName || currency?.code || ''}`
                        };
                    })}
                />
            )}

            {/* Loading - shows only when there's no data yet */}
            {shouldShowLoading && <FeeDisplay defaultLabel={lang.orderForm.estimatingFees} isLoading={true} />}
        </Fragment>
    );
};

export default FeePreview;
